/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import Checkbox from '@mui/material/Checkbox';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Settings page components
import FormField from "layouts/pages/account/components/FormField";

// Data
import selectData from "layouts/pages/account/settings/components/BasicInfo/data/selectData";
import { useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import MDButton from "components/MDButton";
// import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ApiCalls from "services/flick_erp_api_call";
import Header from "../Header";
import {
  FormControl,
  Icon,
  IconButton,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  Switch,
  TextField,
	Tooltip,
} from "@mui/material";
import { AccountBalance, AccountCircle, CheckBox, CheckBoxOutlineBlankTwoTone, CheckBoxRounded, Delete, FormatListBulleted, HomeOutlined, Info, InfoOutlined, InfoRounded, InfoTwoTone, Person, RecentActorsOutlined, ShieldOutlined } from "@mui/icons-material";
import { setToastOpen } from "components/Toast/toastAlertSlice";
import { useDispatch } from "react-redux";
import { useForm, useFormContext } from "react-hook-form";
import TripleToggleSwitch from "components/ThreeWaySwitch";
import { ReportingManager } from '../ReportingManager';
import { LeaveBalance } from '../LeaveBalance';
import ChangePassword from '../ChangePassword';
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import { useTheme } from "@mui/material/styles";
import { useMaterialUIController } from "context";

function BasicInfo({
  data,
	branch,
  employee,
  handleImageSelect,
  isCreateEmployee,
  Employee,
  setEmployee,
  permissions,
  modulePermissions,
  reloadCallback,
  setIsReloadRequest,
}) {
  const theme = useTheme();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const palette = theme.palette;
  // debugger;
  const currentUser = JSON.parse(localStorage.getItem("user"));

  const emptyAddress = {
    id: null,
    address_type: "",
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    is_primary: false,
  };
  const emptyFamilyContact = {
    id: null,
    name: "",
    relation: "",
    mobile: "",
    is_emergency_contact: false,
  };
  const emptyPersonalInfo = {
    id: null,
    pan_number: "",
    aadhaar_number: "",
    pf_number: "",
    esic_number: "",
  };
  const genderData = [
    { name: "Male", id: "m" },
    { name: "Female", id: "f" },
  ];

  const getGenderId = (gender) => {
    return genderData.find((e) => e?.id == gender?.id)?.id;
  };
  const [firstname, setFirstname] = useState("");
  const [empId, setEmpId] = useState("");
  const [lastname, setLastname] = useState("");
  const [gender, setGender] = useState("");
  const [dob, setDob] = useState("");
  const [doj, setDoj] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [designationValue, setDesignationValue] = useState("");
  const [branchValue, setBranchValue] = useState("");
  const [roleValue, setRoleValue] = useState("");
  const [status, setStatus] = useState("active");
  const [attendanceCheck, setAttendanceCheck] = useState("false");
  const [addressForms, setAddressForms] = useState({
    permanent: { ...emptyAddress, address_type: "permanent", is_primary: true },
    current: { ...emptyAddress, address_type: "current" },
    other: { ...emptyAddress, address_type: "other" },
  });
  const [familyContacts, setFamilyContacts] = useState({
    mother: { ...emptyFamilyContact, relation: "mother" },
    father: { ...emptyFamilyContact, relation: "father" },
    other: { ...emptyFamilyContact, relation: "other", is_emergency_contact: true },
  });
  const [personalInfoForm, setPersonalInfoForm] = useState(emptyPersonalInfo);

  const [roles, setRoles] = useState([]);
  const [departments, setDepartment] = useState([]);
  //const [branch, setBranch] = useState([]);
  // const [img, setImg] = useState("");
  const {
    register,
    formState: { errors },
    setValue,
  } = useForm();

  useEffect(() => {
    setFirstname(data?.user?.firstname || "");
    setStatus(
      data?.status ?? "active"
    );
    setLastname(data?.user?.lastname || "");
    setEmpId(data?.emp_id || "");
    setGender(genderData.find((e) => e.id == data?.gender) || genderData[0]);
    setDob(formatDate(data?.dob) || "");
    setDoj(formatDate(data?.doj) || "");
    setEmail(data?.user?.email || "");
    setPhone(data?.user?.phone || "");
    setRoleValue(data?.role || "");
    setDesignationValue(data?.designation.id || "");
    setBranchValue(data?.branch || "");
    setAttendanceCheck(data?.attendance_check || false)
  }, [data]);

  useEffect(() => {
    const addressList = Array.isArray(data?.addresses)
      ? data.addresses
      : Array.isArray(data?.employee_addresses)
      ? data.employee_addresses
      : Array.isArray(data?.employee_address)
      ? data.employee_address
      : [];
    const familyList = Array.isArray(data?.family_contacts)
      ? data.family_contacts
      : Array.isArray(data?.employee_family_contacts)
      ? data.employee_family_contacts
      : Array.isArray(data?.family_contact)
      ? data.family_contact
      : [];
    const personalInfoSource = Array.isArray(data?.personal_info)
      ? data.personal_info[0]
      : Array.isArray(data?.employee_personal_info)
      ? data.employee_personal_info[0]
      : data?.personal_info || data?.employee_personal_info || {};

    const findAddress = (type) =>
      addressList.find((item) => String(item?.address_type || "").toLowerCase() === type) || {};
    const findFamily = (relation) =>
      familyList.find((item) => String(item?.relation || "").toLowerCase() === relation) || {};

    setAddressForms({
      permanent: { ...emptyAddress, address_type: "permanent", is_primary: true, ...findAddress("permanent") },
      current: { ...emptyAddress, address_type: "current", ...findAddress("current") },
      other: { ...emptyAddress, address_type: "other", ...findAddress("other") },
    });
    setFamilyContacts({
      mother: { ...emptyFamilyContact, relation: "mother", ...findFamily("mother") },
      father: { ...emptyFamilyContact, relation: "father", ...findFamily("father") },
      other: { ...emptyFamilyContact, relation: "other", is_emergency_contact: true, ...findFamily("other") },
    });
    setPersonalInfoForm({ ...emptyPersonalInfo, ...personalInfoSource });
  }, [data]);
  useEffect(() => {
    getRoles();
    getDepartment();
  }, []);

// useEffect(() => {
//  if (permissions?.includes(modulePermissions.update_permission)){
//    getBranch();
//  }
//}, [permissions]);

  const navigate = useNavigate();
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const formattedDate = date.toISOString().slice(0, 10);
    return formattedDate;
  };
  const dispatch = useDispatch();
  const location = useLocation();
  const user_id = location.state?.userid ?? data?.id;
  const user = JSON.parse(localStorage.getItem("user"));
  const resolvedBranchName =
    branch?.find((item) => String(item.id) === String(branchValue))?.name || "";
  const ui = {
    card: darkMode ? palette.background.card : colors.white.main,
    soft: darkMode ? rgba(palette.background.muted, 0.78) : rgba(colors.background.elevated, 0.46),
    border: darkMode ? rgba(palette.white.main, 0.08) : rgba(colors.secondary.main, 0.1),
    title: darkMode ? palette.text.focus : colors.dark.main,
    body: darkMode ? palette.text.main : colors.text.main,
    shadow: darkMode ? "0 18px 40px rgba(2, 6, 23, 0.28)" : `0 18px 40px ${rgba(colors.dark.main, 0.06)}`,
  };

  const canEditProfile = permissions?.includes(modulePermissions.update_permission);

  const handleAddressChange = (type, field, value) => {
    setAddressForms((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [field]: value,
      },
    }));
  };

  const handleFamilyChange = (type, field, value) => {
    setFamilyContacts((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [field]: value,
      },
    }));
  };

  const saveAddress = async (type) => {
    const form = addressForms[type];
    const payload = {
      address_type: type,
      address_line1: form.address_line1,
      address_line2: form.address_line2,
      city: form.city,
      state: form.state,
      pincode: form.pincode,
      country: form.country,
      is_primary: !!form.is_primary,
      org: currentUser?.org_id,
      employee: data?.id,
    };
    const response = form?.id
      ? await ApiCalls.patchEmployeeAddress(form.id, payload)
      : await ApiCalls.postEmployeeAddress(payload);
    if (response?.success) reloadCallback?.();
  };

  const deleteAddress = async (type) => {
    const form = addressForms[type];
    if (!form?.id) {
      setAddressForms((prev) => ({
        ...prev,
        [type]: { ...emptyAddress, address_type: type, is_primary: type === "permanent" },
      }));
      return;
    }
    const response = await ApiCalls.deleteEmployeeAddress(form.id);
    if (response?.success) reloadCallback?.();
  };

  const saveFamilyContact = async (type) => {
    const form = familyContacts[type];
    const payload = {
      name: form.name,
      relation: type,
      mobile: form.mobile,
      is_emergency_contact: !!form.is_emergency_contact,
      org: currentUser?.org_id,
      employee: data?.id,
    };
    const response = form?.id
      ? await ApiCalls.patchEmployeeFamilyContact(form.id, payload)
      : await ApiCalls.postEmployeeFamilyContact(payload);
    if (response?.success) reloadCallback?.();
  };

  const deleteFamilyContact = async (type) => {
    const form = familyContacts[type];
    if (!form?.id) {
      setFamilyContacts((prev) => ({
        ...prev,
        [type]: { ...emptyFamilyContact, relation: type, is_emergency_contact: type === "other" },
      }));
      return;
    }
    const response = await ApiCalls.deleteEmployeeFamilyContact(form.id);
    if (response?.success) reloadCallback?.();
  };

  const savePersonalInfo = async () => {
    const payload = {
      pan_number: personalInfoForm.pan_number,
      aadhaar_number: personalInfoForm.aadhaar_number,
      pf_number: personalInfoForm.pf_number,
      esic_number: personalInfoForm.esic_number,
      org: currentUser?.org_id,
      employee: data?.id,
    };
    const response = personalInfoForm?.id
      ? await ApiCalls.patchEmployeePersonalInfo(personalInfoForm.id, payload)
      : await ApiCalls.postEmployeePersonalInfo(payload);
    if (response?.success) reloadCallback?.();
  };

  const deletePersonalInfo = async () => {
    if (!personalInfoForm?.id) {
      setPersonalInfoForm(emptyPersonalInfo);
      return;
    }
    const response = await ApiCalls.deleteEmployeePersonalInfo(personalInfoForm.id);
    if (response?.success) reloadCallback?.();
  };

  const renderSectionCard = (title, subtitle, icon, content, actions = null) => (
    <Card
      sx={{
        overflow: "visible",
        borderRadius: "28px",
        border: `1px solid ${rgba(colors.secondary.main, 0.1)}`,
        boxShadow: `0 18px 40px ${rgba(colors.dark.main, 0.06)}`,
        mb: 3,
      }}
    >
      <MDBox
        p={3}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: `1px solid ${rgba(colors.secondary.main, 0.08)}`,
        }}
      >
        <MDBox display="flex" alignItems="center" gap={3}>
          <MDBox
            sx={{
              width: 48,
              height: 48,
              borderRadius: "16px",
              display: "grid",
              placeItems: "center",
              background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
              color: colors.white.main,
            }}
          >
            {icon}
          </MDBox>
          <MDBox>
            <MDTypography variant="h5">{title}</MDTypography>
            <MDTypography variant="body2" color="text" sx={{ mt: 0.35 }}>
              {subtitle}
            </MDTypography>
          </MDBox>
        </MDBox>
        {actions}
      </MDBox>
      <MDBox p={3}>{content}</MDBox>
    </Card>
  );

  const renderAddressBlock = (type, label) => {
    const form = addressForms[type];
    return (
      <Grid item xs={12} md={4} key={type}>
        <MDBox
          sx={{
            p: 2,
            borderRadius: "22px",
            //backgroundColor: rgba(colors.background.elevated, 0.46),
						backgroundColor : ui.soft,
            //border: `1px solid ${rgba(colors.secondary.main, 0.08)}`,
						border: `1px solid ${ui.border}`,
            height: "100%",
          }}
        >
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
						<MDTypography variant="h6">{label}</MDTypography>
						{canEditProfile && <MDBox>
							<IconButton onClick={() => saveAddress(type)}><Icon color='primary'>save</Icon></IconButton>
							<IconButton onClick={() => deleteAddress(type)}><Icon color='error'>delete</Icon></IconButton>
						</MDBox>}
					</MDBox>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField label="Address Line 1" fullWidth variant="standard" value={form.address_line1 || ""} disabled={!canEditProfile} onChange={(e) => handleAddressChange(type, "address_line1", e.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Address Line 2" fullWidth variant="standard" value={form.address_line2 || ""} disabled={!canEditProfile} onChange={(e) => handleAddressChange(type, "address_line2", e.target.value)} />
            </Grid>
            <Grid item xs={6}>
              <TextField label="City" fullWidth variant="standard" value={form.city || ""} disabled={!canEditProfile} onChange={(e) => handleAddressChange(type, "city", e.target.value)} />
            </Grid>
            <Grid item xs={6}>
              <TextField label="State" fullWidth variant="standard" value={form.state || ""} disabled={!canEditProfile} onChange={(e) => handleAddressChange(type, "state", e.target.value)} />
            </Grid>
            <Grid item xs={6}>
              <TextField label="Pincode" fullWidth variant="standard" value={form.pincode || ""} disabled={!canEditProfile} onChange={(e) => handleAddressChange(type, "pincode", e.target.value)} />
            </Grid>
            <Grid item xs={6}>
              <TextField label="Country" fullWidth variant="standard" value={form.country || ""} disabled={!canEditProfile} onChange={(e) => handleAddressChange(type, "country", e.target.value)} />
            </Grid>
            {canEditProfile && (
              <Grid item xs={12}>
                <MDBox display="flex" justifyContent="flex-end" alignItems="center">
                  <FormControlLabel
                    control={<Checkbox checked={!!form.is_primary} onChange={(e, value) => handleAddressChange(type, "is_primary", value)} />}
                    label="Primary"
                  />
                  {/*<MDBox display="flex" gap={1}>
                    <MDButton size="small" variant="outlined" color="error" onClick={() => deleteAddress(type)}>Delete</MDButton>
                    <MDButton size="small" variant="gradient" color="info" onClick={() => saveAddress(type)}>Save</MDButton>
                  </MDBox>*/}
                </MDBox>
              </Grid>
            )}
          </Grid>
        </MDBox>
      </Grid>
    );
  };

  const renderFamilyBlock = (type, label) => {
    const form = familyContacts[type];
    return (
      <Grid item xs={12} md={4} key={type}>
        <MDBox
          sx={{
            p: 2,
            borderRadius: "22px",
            //backgroundColor: rgba(colors.background.elevated, 0.46),
            //border: `1px solid ${rgba(colors.secondary.main, 0.08)}`,
						border: `1px solid ${ui.border}`,
						backgroundColor : ui.soft,
            height: "100%",
          }}
        >
					<MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
						<MDTypography variant="h6">{label}</MDTypography>
						{canEditProfile && (
							<MDBox>
								<IconButton onClick={() => saveFamilyContact(type)}><Icon color='primary'>save</Icon></IconButton>
								<IconButton onClick={() => deleteFamilyContact(type)}><Icon color='error'>delete</Icon></IconButton>
							</MDBox>
						)}
					</MDBox>
          
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField label="Name" fullWidth variant="standard" value={form.name || ""} disabled={!canEditProfile} onChange={(e) => handleFamilyChange(type, "name", e.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Mobile" fullWidth variant="standard" value={form.mobile || ""} disabled={!canEditProfile} onChange={(e) => handleFamilyChange(type, "mobile", e.target.value)} />
            </Grid>
            {canEditProfile && (
              <Grid item xs={12}>
                <MDBox display="flex" justifyContent="flex-end" alignItems="center">
                  <FormControlLabel
                    control={<Checkbox checked={!!form.is_emergency_contact} onChange={(e, value) => handleFamilyChange(type, "is_emergency_contact", value)} />}
                    label="Emergency Contact"
                  />
                  {/*<MDBox display="flex" gap={1}>
                    <MDButton size="small" variant="outlined" color="error" onClick={() => deleteFamilyContact(type)}>Delete</MDButton>
                    <MDButton size="small" variant="gradient" color="info" onClick={() => saveFamilyContact(type)}>Save</MDButton>
                  </MDBox>*/}
                </MDBox>
              </Grid>
            )}
          </Grid>
        </MDBox>
      </Grid>
    );
  };

  async function getDepartment() {
    var res = await ApiCalls.getDepartment();
    if (res.success && res.code == 200) {
      setDepartment(res.data);
    } else {
    }
  }

  //async function getBranch() {
  //  var res = await ApiCalls.getBranch();
  //  if (res.success && res.code == 200) {
  //    setBranch(res.data);
  //  } else {
  //  }
  //}

  useEffect(() => {
    const fields = [
      "firstname",
      "lastname",
      "gender",
      "dob",
      "doj",
      "designationValue",
      "branchValue",
      "phone",
      "empId",
      "roles",
      "email",
      "password",
    ];
    fields.forEach((field) => {
      register(field, { required: "required" });
    });
  }, [register]);

  // Get Organisation Roles
  async function getRoles() {
    var res = await ApiCalls.getRoles();
    if (res.success && res.code == 200) {
      setRoles(res.data);
    } else {
    }
  }

  const setEmployeeStatus = async (val) => {
    const obj = {
      status: val,
    };
    const res = await ApiCalls.editEmployee(data?.id, obj, false);
    if (res.success && res.code === 200) {
      reloadCallback();
    } else {
    }
  };
  const handleSubmit = async () => {
    try {
      const updatedData = {
        user: {
          id: data.user.id.toString(),
          firstname: firstname,
          lastname: lastname,
          phone: phone,
          email:email
        },

        emp_id: empId,
        gender: getGenderId(gender),
        dob: dob,
        doj: doj,
        role: roleValue,
        designation: designationValue,
        branch: branchValue,
      };
      if(email == data.user.email) {
        delete updatedData.user.email
      }
      if(phone == data.user.phone) {
        delete updatedData.user.phone
      }

      const formIsValid = isFormInvalid(updatedData);
      if (formIsValid) {
        const res = await ApiCalls.editEmployee(data?.id, updatedData, false);
        if (res.success && res.code === 200) {
          reloadCallback();
        } else {
        }
      }
    } catch (error) {
      console.error(error);
    }
    return;
  };

  const isFormInvalid = (updatedData) => {
    let isValid = true;

    const fieldsToCheck = [
      "user.firstname",
      "user.lastname",
      "emp_id",
      "gender",
      "dob",
      "doj",
      "role",
      // 'designation',
    ];

    for (const field of fieldsToCheck) {
      const fieldNames = field.split(".");
      let fieldValue = updatedData;

      for (const fieldName of fieldNames) {
        if (
          fieldValue &&
          fieldValue[fieldName] !== "" &&
          fieldValue[fieldName] !== undefined
        ) {
          fieldValue = fieldValue[fieldName];
        } else {
          setValue(field, "", { shouldValidate: true });
          isValid = false;
          break;
        }
      }
    }

    return isValid;
  };

  const handleDelete = async () => {
    try {
      const res = await ApiCalls.deleteEmployee(data?.id);
      if (res.success && res.code === 204) {
        navigate("/employee/employees");
      } else {
      }
    } catch (error) {
      console.error(error);
    }
  };
  const labels = {
    left: {
      title: "Deactive",
      value: "deactive",
    },
    right: {
      title: "Notice",
      value: "notish",
    },
    center: {
      title: "Active",
      value: "active",
    },
  };
  function hideKey(object, key) {
    if (object.hasOwnProperty(key)) {
      Object.defineProperty(object, key, { enumerable: false });
    }
  }

	const renderTooltipMessage = () => (
		<MDBox sx={{display:'flex', justifyContent:'center', flexDirection:"column"}}>
			<MDBox sx={{display : "flex", gap:'4px'}}>
				<Icon sx={{color : 'White', marginTop:'4px'}}><CheckBox/></Icon>
				<MDTypography variant="body2" sx={{color : "White"}}>Notice Period of 90 days is applicable as per company policy and must be adhered to in accordance with the terms of employment.</MDTypography>
			</MDBox>
			<MDBox display="flex" gap={1}>
				<Icon sx={{color : "White", marginTop:'4px'}}><CheckBox/></Icon>
				<MDTypography variant="body2" sx={{color : "White"}}>The Probation Period will be effective from the date of joining and shall be governed by the company’s policy, applicable to all employees.</MDTypography>
			</MDBox>
			<MDBox>

			</MDBox>
		</MDBox>
	)

  return (
    <div>
      
      {/* {!isCreateEmployee && (
        <MDBox>
          <MDBox bgColor="info">
          
          </MDBox>
          { permissions?.includes(modulePermissions.update_permission) &&(<MDBox display="flex" justifyContent="end" alignItems="center" pr={3}>
          <TripleToggleSwitch value={status} labels={labels} onChange={(value)=> {
            setStatus(value)
            setEmployeeStatus(value)
          }} />
          
          </MDBox>)}
          <Header
            data={data}
            userId={user_id}
            permissions={permissions}
            modulePermissions={modulePermissions}
          />
        </MDBox>
      )} 
      <br /> */}
      <Card
        id="basic-info"
        sx={{
          overflow: "visible",
          borderRadius: "28px",
          border: `1px solid ${ui.border}`,
          backgroundColor: ui.card,
          boxShadow: ui.shadow,
        }}
      >
        <MDBox
          p={3}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: `1px solid ${ui.border}`,
          }}
        >
					<MDBox display="flex" alignItems='center' gap={3}>
						<MDBox
							sx={{
								width: 48,
								height: 48,
								borderRadius: "16px",
								display: "grid",
								placeItems: "center",
								background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
								color: colors.white.main,
							}}
						>
							<Person />
						</MDBox>
						<MDBox>
							<MDBox display = 'flex' gap={1} alignItems='center'>
								<MDTypography variant="h5" sx={{ color: ui.title }}>
									Personal Information
								</MDTypography>
								<Tooltip title={renderTooltipMessage()}>
									<Icon><InfoRounded/></Icon>
                </Tooltip>
								{/*<IconButton><Icon color={colors.dark.main}><InfoOutlined fontSize='small'/></Icon></IconButton>*/}
							</MDBox>
							<MDTypography variant="body2" sx={{ mt: 0.35, color: ui.body }}>
								Review employee identity, role, and contact details in one place.
							</MDTypography>
						</MDBox>
					</MDBox>

          <MDBox display='flex' gap={3}>
          {permissions?.includes(modulePermissions?.delete_permission) && (
            <IconButton
              onClick={() => {
                handleDelete();
              }}
              sx={{
                width: 40,
                height: 40,
                borderRadius: "14px",
                backgroundColor: rgba(colors.error.main, 0.1),
                color: colors.error.main,
              }}
            >
              <Delete />
            </IconButton>
          )}
					{!isCreateEmployee &&
              permissions?.includes(modulePermissions?.update_permission) && (
                  <MDButton
                    color="info"
                    sx={{ px: 3, borderRadius: "14px" }}
                    onClick={() => handleSubmit()}
                  >
                    Save Details
                  </MDButton>
              )}
					</MDBox>
        </MDBox>
        <MDBox component="form" pb={3} px={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MDBox
                sx={{
                  p: 2,
                  borderRadius: "22px",
                  backgroundColor: ui.soft,
                  border: `1px solid ${ui.border}`,
                }}
              >
                <MDTypography variant="h6" sx={{ color: ui.title, mb: 2.25 }}>
                  Identity
                </MDTypography>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <FormField
                      label="First Name"
                      placeholder="Alex"
                      value={firstname}
                      onChange={(e) => {
                        setEmployee({ ...Employee, firstName: e.target.value });
                        setFirstname(e.target.value);
                        setValue("firstname", e.target.value, {
                          shouldValidate: true,
                        });
                      }}
                      error={errors.firstname}
                      inputProps={{
                        readOnly: !isCreateEmployee
                          ? !permissions?.includes(modulePermissions.update_permission)
                          : false,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormField
                      label="Last Name"
                      placeholder="Volkov"
                      value={lastname}
                      onChange={(e) => {
                        setEmployee({ ...Employee, lastName: e.target.value });
                        setLastname(e.target.value);
                        setValue("lastname", e.target.value, {
                          shouldValidate: true,
                        });
                      }}
                      error={errors.lastname}
                      inputProps={{
                        readOnly: !isCreateEmployee
                          ? !permissions?.includes(modulePermissions.update_permission)
                          : false,
                      }}
                    />
                  </Grid>
                </Grid>
              </MDBox>
            </Grid>
            <Grid item xs={12}>
              <MDBox
                sx={{
                  p: 2,
                  borderRadius: "22px",
                  backgroundColor: ui.soft,
                  border: `1px solid ${ui.border}`,
                }}
              >
                <MDTypography variant="h6" sx={{ color: ui.title, mb: 2.25 }}>
                  Personal Details
                </MDTypography>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      value={gender}
                      options={genderData}
                      getOptionLabel={(e) => e.name}
                      onChange={(event, values) => {
                        setEmployee({
                          ...Employee,
                          gender: values,
                        });
                        setGender(values);
                        setValue("gender", values, { shouldValidate: true });
                      }}
                      renderInput={(params) => (
                        <FormField
                          label="Gender"
                          {...params}
                          placeholder="M/F"
                          InputLabelProps={{ shrink: true }}
                          value={gender}
                          error={errors.gender}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <FormField
                      label="Date of Birth"
                      placeholder="DD/MM/YY"
                      value={dob}
                      onChange={(e) => {
                        setEmployee({ ...Employee, dob: e.target.value });
                        setDob(e.target.value);
                        setValue("dob", e.target.value, {
                          shouldValidate: true,
                        });
                      }}
                      error={errors.dob}
                      inputProps={{
                        type: "date",
                        readOnly: !isCreateEmployee
                          ? !permissions?.includes(modulePermissions.update_permission)
                          : false,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <FormField
                      label="Date of Joining"
                      placeholder="DD/MM/YY"
                      value={doj}
                      onChange={(e) => {
                        setEmployee({ ...Employee, doj: e.target.value });
                        setDoj(e.target.value);
                        setValue("doj", e.target.value, {
                          shouldValidate: true,
                        });
                      }}
                      error={errors.doj}
                      inputProps={{
                        type: "date",
                        readOnly: !isCreateEmployee
                          ? !permissions?.includes(modulePermissions.update_permission)
                          : false,
                      }}
                    />
                  </Grid>
                </Grid>
              </MDBox>
            </Grid>
            <Grid item xs={12}>
              <MDBox
                sx={{
                  p: 2,
                  borderRadius: "22px",
                  backgroundColor: ui.soft,
                  border: `1px solid ${ui.border}`,
                }}
              >
                <MDTypography variant="h6" sx={{ color: ui.title, mb: 2.25 }}>
                  Contact & Work
                </MDTypography>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <FormField
                      label="Email"
                      placeholder="example@email.com"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setEmployee({ ...Employee, email: e.target.value });
                        setValue("email", e.target.value, { shouldValidate: true });
                      }}
                      inputProps={{
                        type: "email",
                        readOnly: !isCreateEmployee
                          ? !permissions?.includes(modulePermissions.update_permission)
                          : false,
                      }}
                    />
                  </Grid>
            {isCreateEmployee && (
                  <Grid item xs={12} sm={6}>
                    <FormField
                      label="Password"
                      type="password"
                      placeholder="********"
                      value={password}
                      onChange={(e) => {
                        isCreateEmployee ? setPassword(e.target.value) : null;
                        setEmployee({ ...Employee, password: e.target.value });
                        setValue("password", e.target.value, {
                          shouldValidate: true,
                        });
                      }}
                      error={errors.password}
                      inputProps={{
                        readOnly: !isCreateEmployee
                          ? !permissions?.includes(modulePermissions.update_permission)
                          : false,
                      }}
                    />
                  </Grid>
            )}

                  <Grid item xs={12} sm={6}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <FormField
                          label="Phone Number"
                          placeholder="+40 735 631 620"
                          value={phone}
                          onChange={(e) => {
                            setEmployee({ ...Employee, phone: e.target.value });
                            setPhone(e.target.value);
                            setValue("phone", e.target.value, {
                              shouldValidate: true,
                            });
                          }}
                          error={errors.phone}
                          inputProps={{
                            type: "number",
                            readOnly: !isCreateEmployee
                              ? !permissions?.includes(modulePermissions.update_permission)
                              : false,
                          }}
                        />
                      </Grid>
												<Grid item xs={12} sm={6} alignSelf={"flex-end"}>
													{permissions?.includes(modulePermissions.update_permission) ? (
													<FormControlLabel
														control={
															<Checkbox
																checked={!!attendanceCheck}
																onChange={(e, value) => {
																	setAttendanceCheck(value);
																}}
																name="attendance_check"
															/>
														}
														sx={{ marginTop: "15px" }}
														label="Attendance Check Required"
													/>
													) : <></>
											}
												</Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={6} alignSelf={"end"}>
              <FormControl fullWidth sx={{}} variant="standard">
                <InputLabel htmlFor="grouped-native-select">
                  Select Designation
                </InputLabel>
                <Select
                  fullWidth
                  native
                  value={designationValue || 0}
                  id="grouped-native-select"
                  label="Grouping"
                  onChange={(event) => {
                    setDesignationValue(event.target?.value);
                    setEmployee({
                      ...Employee,
                      designation: event.target?.value,
                    });
                    setValue("designationValue", event.target?.value, {
                      shouldValidate: true,
                    });
                  }}
									 disabled={
                            !isCreateEmployee
                              ? !permissions?.includes(modulePermissions.update_permission)
                              : false
                          }
                  error={errors.designationValue}
                >
                  <option aria-label="None" value="" />
                  {departments.map(function (e) {
                    return (
                      <>
                        <optgroup label={e.name}>
                          {e.designations.map(function (designation) {
                            return (
                              <>
                                <option value={designation.id}>
                                  {designation.name}
                                </option>
                              </>
                            );
                          })}
                        </optgroup>
                      </>
                    );
                  })}
                </Select>
              </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} alignSelf={"end"}>
              <FormControl fullWidth sx={{}} variant="standard">
                {permissions?.includes(modulePermissions.update_permission) ? (
                <>
                <InputLabel htmlFor="grouped-native-select">
                      Branch
                    </InputLabel>
                <Select
                  fullWidth
                  native
                  value={branchValue || 0}
                  id="grouped-native-select"
                  label="Grouping"
                  onChange={(event) => {
                    const value = Number(event.target.value);
                    setBranchValue(value);
                    // setEmployee({
                    //   ...Employee,
                    //   designation: event.target?.value,
                    // });
                    setValue("branchValue", event.target?.value, {
                      shouldValidate: true,
                    });
                  }}
                  error={errors.branchValue}
                >
                  <option aria-label="None" value="">
                    Select Branch
                  </option>
                  {branch.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
                </>
                ) : (
                  <>
                    <TextField
                      variant="standard"
                      label="Branch"
                      value={resolvedBranchName}
                      disabled
                    />

                  </>
                )}
              </FormControl>
                  </Grid>

									<Grid item xs={12} sm={3}>
                     <Autocomplete
                          id={"roles"}
                          options={roles}
                          value={roles?.filter((e) => e.id == roleValue)[0] || ""}
                          sx={{}}
                          getOptionLabel={(option) => option.name || ""}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="Roles"
                              label={"Select Roles"}
                              variant="standard"
                              error={errors.roles}
                            />
                          )}
                          readOnly={
                            !isCreateEmployee
                              ? !permissions?.includes(modulePermissions.update_permission)
                              : false
                          }
                          onChange={(event, newValue) => {
                            setRoleValue(newValue?.id);
                            setEmployee({ ...Employee, role: newValue?.id });
                            setValue("roles", newValue?.id, {
                              shouldValidate: true,
                            });
                          }}
                        />
                  </Grid>

									<Grid item xs={12} sm={3}>
                    <FormField
                          label="Employee ID"
                          placeholder="0"
                          value={empId}
                          onChange={(e) => {
                            setEmployee({ ...Employee, emp_id: e.target.value });
                            setEmpId(e.target.value);
                            setValue("empId", e.target.value, {
                              shouldValidate: true,
                            });
                          }}
                          error={errors.empId}
                          inputProps={{
                            readOnly: !isCreateEmployee
                              ? !permissions?.includes(modulePermissions.update_permission)
                              : false,
                          }}
                        />
                  </Grid>

									<Grid item xs={12} sm={6}>
                    {permissions?.includes(modulePermissions?.update_permission) ? (
												<MDBox display="flex" justifyContent="end" mt={3} alignItems="center">
													<TripleToggleSwitch
														value={data?.status}
														labels={labels}
														onChange={(value) => setEmployeeStatus(value)}
													/>
												</MDBox>
											) : null
										}
                  </Grid>
                  
                </Grid>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
      <br/>
     {(permissions?.includes(modulePermissions.reporting_structure_owner_list_permission) || permissions?.includes(modulePermissions.reporting_structure_list_permission)) && <> <Card
      id='managers'
      sx={{
        overflow: "visible",
        borderRadius: "28px",
        border: `1px solid ${rgba(colors.secondary.main, 0.1)}`,
        boxShadow: `0 18px 40px ${rgba(colors.dark.main, 0.06)}`,
      }}
    >
        <ReportingManager
                    data={data}
                    isCreateEmployee={isCreateEmployee}
                    Employee={employee}
                    setEmployee={setEmployee}
                    permissions={permissions}
                    modulePermissions={modulePermissions}
                    reloadCallback = {reloadCallback}
                  />
      </Card></>}
      <br/>
      {
			(permissions?.includes(modulePermissions?.update_permission )|| data?.id === currentUser.employee_id) && 
			renderSectionCard(
        "Addresses",
        "Maintain permanent, current, and other employee addresses.",
        <HomeOutlined />,
        <Grid container spacing={2}>
          {renderAddressBlock("permanent", "Permanent")}
          {renderAddressBlock("current", "Present")}
          {renderAddressBlock("other", "Other")}
        </Grid>
      )}

      {
			(permissions?.includes(modulePermissions?.update_permission )|| data?.id === currentUser.employee_id)  && 
			renderSectionCard(
        "Family Contacts",
        "Store emergency and family contact details for the employee.",
        <RecentActorsOutlined />,
        <Grid container spacing={2}>
          {renderFamilyBlock("mother", "Mother")}
          {renderFamilyBlock("father", "Father")}
          {renderFamilyBlock("other", "Other")}
        </Grid>
      )}

      {
			
			(permissions?.includes(modulePermissions?.update_permission )|| data?.id === currentUser.employee_id ) && renderSectionCard(
        "Personal & Official IDs",
        "Aadhaar and PAN under personal IDs, PF and ESIC under official IDs.",
        <ShieldOutlined />,
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <MDBox
              sx={{
                p: 2,
                borderRadius: "22px",
                //backgroundColor: rgba(colors.background.elevated, 0.46),
								backgroundColor : ui.soft,
                border: `1px solid ${ui.border}}`,
                //border: `1px solid ${rgba(colors.secondary.main, 0.08)}`,
              }}
            >
              <MDTypography variant="h6" sx={{ mb: 2 }}>Personal</MDTypography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField label="Aadhaar Number" fullWidth variant="standard" value={personalInfoForm.aadhaar_number || ""} disabled={!canEditProfile} onChange={(e) => setPersonalInfoForm((prev) => ({ ...prev, aadhaar_number: e.target.value }))} />
                </Grid>
                <Grid item xs={12}>
                  <TextField label="PAN Number" fullWidth variant="standard" value={personalInfoForm.pan_number || ""} disabled={!canEditProfile} onChange={(e) => setPersonalInfoForm((prev) => ({ ...prev, pan_number: e.target.value }))} />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6}>
            <MDBox
              sx={{
                p: 2,
                borderRadius: "22px",
                //backgroundColor: rgba(colors.background.elevated, 0.46),
								backgroundColor : ui.soft,
                border: `1px solid ${ui.border}`,
              }}
            >
              <MDTypography variant="h6" sx={{ mb: 2 }}>Official</MDTypography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField label="PF Number" fullWidth variant="standard" value={personalInfoForm.pf_number || ""} disabled={!canEditProfile} onChange={(e) => setPersonalInfoForm((prev) => ({ ...prev, pf_number: e.target.value }))} />
                </Grid>
                <Grid item xs={12}>
                  <TextField label="ESIC Number" fullWidth variant="standard" value={personalInfoForm.esic_number || ""} disabled={!canEditProfile} onChange={(e) => setPersonalInfoForm((prev) => ({ ...prev, esic_number: e.target.value }))} />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
          {canEditProfile && (
            <Grid item xs={12}>
              <MDBox display="flex" justifyContent="flex-end" gap={1}>
                <MDButton size="small" variant="outlined" color="error" onClick={deletePersonalInfo}>Delete</MDButton>
                <MDButton size="small" color="info" onClick={savePersonalInfo}>Save</MDButton>
              </MDBox>
            </Grid>
          )}
        </Grid>
      )}

     {/*{permissions?.includes(modulePermissions.update_permission) && <> <Card
      id='leave-balance'
      sx={{
        overflow: "visible",
        borderRadius: "28px",
        border: `1px solid ${rgba(colors.secondary.main, 0.1)}`,
        boxShadow: `0 18px 40px ${rgba(colors.dark.main, 0.06)}`,
      }}
    >
        <LeaveBalance
                    permissionKey="leave"
                    data={data}
                    isCreateEmployee={isCreateEmployee}
                    Employee={employee}
                    setEmployee={setEmployee}
                    permissions={permissions}
                    modulePermissions={modulePermissions}
                    setIsReloadRequest={setIsReloadRequest}
                  />
      </Card> <br/></>}*/}
      {/* {permissions?.includes(modulePermissions.update_permission) && 
      <> */}
      {/* <Card id='change-password' sx={{overflow : "visible"}}>
      <ChangePassword
            data={data}
            isCreateEmployee={isCreateEmployee}
            Employee={employee}
            setEmployee={setEmployee}
            permissions={permissions}
            modulePermissions={modulePermissions}
          />
      </Card> <br/> */}
      {/* </>} */}
    </div>
  );
}
export default BasicInfo;
